import { Box, Container, Flex, HStack, Heading, Highlight, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { logEvent } from "../../utils/google-analytics-lib/analytics";

export default function WidgetLayout() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const isVisible = rect.top + rect.height * 0.2 < window.innerHeight && rect.bottom >= 0;
        setIsVisible(isVisible);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleWidgetLayoutTabChange = (index: number) => {
    const widgetLayout = index === 0 ? "Grid View" : index === 1 ? "List View" : "Star Ratings";
    logEvent("Hero Content", "Click", `Widget Layout - ${widgetLayout}`);
  };
  return (
    <Container w={"100%"} maxW={"8xl"} pb={"30px"} overflow={"hidden"} mt={"150px"}>
      <Heading px={"5px"} lineHeight="tall" fontFamily={"heading"} textAlign={"center"} fontSize={{ base: "3xl", md: "3xl", lg: "5xl" }}>
        <Highlight query="Widget Style That Aligns" styles={{ px: "1", py: "1", rounded: "full", textDecoration: "underline", textDecorationStyle: "wavy", textDecorationColor: "brand.500", textDecorationThickness: "8px", textUnderlineOffset: "12px" }}>
          Choose a Widget Style That Aligns with Your Brand's Identity
        </Highlight>
      </Heading>
      <Tabs variant="soft-rounded" colorScheme="brand" ref={ref} onChange={handleWidgetLayoutTabChange} mt={"100px"}>
        <TabList justifyContent={"center"}>
          <Flex bg={"brand.50"} p={2} rounded={"full"}>
            <Tab _selected={{ color: "white", bg: "brand.500" }} w={{ base: 120, md: 140, lg: 160 }}>
              Grid View
            </Tab>
            <Tab _selected={{ color: "white", bg: "brand.500" }} w={{ base: 120, md: 140, lg: 160 }}>
              List View
            </Tab>
            <Tab _selected={{ color: "white", bg: "brand.500" }} w={{ base: 140, md: 140, lg: 160 }}>
              Star Ratings
            </Tab>
          </Flex>
        </TabList>
        <Text textAlign={"center"} pt={10} fontSize={"xs"} opacity={0.6}>
          **In the following demo, the 'Write a Review,' 'Sort,' and 'Show More Reviews' buttons are disabled."
        </Text>
        <TabPanels className={isVisible ? "animate-fade-right" : "opacity-zero"}>
          <TabPanel>
            <Box borderRadius={"2xl"} height={{ base: "2400px", md: "2700px", lg: "1700px" }}>
              <iframe title={"Grid View"} src="./widgets-test/grid-reviews.html" width="100%" height={"100%"}></iframe>
            </Box>
          </TabPanel>
          <TabPanel>
            <Box borderRadius={"2xl"} height={{ base: "2600px", md: "2000px", lg: "2000px" }}>
              <iframe title={"List View"} src="./widgets-test/list-reviews.html" width="100%" height="100%"></iframe>
            </Box>
          </TabPanel>
          <TabPanel>
            <Box py={10}>
              <HStack spacing={-1} justify={"center"}>
                <StarSvg starColor="#F5D332"></StarSvg>
                <StarSvg starColor="#F5D332"></StarSvg>
                <StarSvg starColor="#F5D332"></StarSvg>
                <StarSvg starColor="#F5D332"></StarSvg>
                <StarSvgPartial starColor="#F5D332"></StarSvgPartial>
                <Text pl={"2px"}>(265)</Text>
              </HStack>
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
}

const StarSvg = ({ starColor }: { starColor: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" style={{ marginLeft: "0" }}>
      <path
        fill={starColor}
        d="M15.9199,11.8203 C15.6599,12.0703 15.5399,12.4393 15.6009,12.7903 L16.4899,17.7103 C16.5609,18.1303 16.3909,18.5493 16.0399,18.7903 C15.6999,19.0403 15.2499,19.0703 14.8699,18.8703 L10.4409,16.5603 C10.2799,16.4803 10.1099,16.4293 9.9409,16.4293 L9.6699,16.4293 C9.5699,16.4393 9.4809,16.4803 9.3999,16.5193 L4.9699,18.8403 C4.7499,18.9503 4.4999,18.9903 4.2599,18.9503 C3.6599,18.8303 3.2709,18.2693 3.3699,17.6793 L4.2599,12.7593 C4.3199,12.4003 4.1999,12.0403 3.9409,11.7803 L0.3299,8.2803 C0.0299,7.9803 -0.0801,7.5493 0.0609,7.1503 C0.1909,6.7593 0.5299,6.4693 0.9499,6.4003 L5.9199,5.6793 C6.2999,5.6393 6.6299,5.4103 6.7999,5.0703 L8.9899,0.5803 C9.0399,0.4803 9.1099,0.3893 9.1909,0.3103 L9.2799,0.2403 C9.3199,0.1893 9.3799,0.1503 9.4409,0.1103 L9.5499,0.0703 L9.7199,0.0003 L10.1409,0.0003 C10.5209,0.0403 10.8509,0.2693 11.0209,0.5993 L13.2399,5.0703 C13.3999,5.4003 13.7099,5.6203 14.0699,5.6793 L19.0399,6.4003 C19.4599,6.4603 19.8109,6.7503 19.9499,7.1503 C20.0799,7.5493 19.9699,7.9903 19.6599,8.2803 L15.9199,11.8203 Z"
        transform="translate(2 2.5)"
      />
    </svg>
  );
};

const StarSvgPartial = ({ starColor }: { starColor: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" style={{ marginLeft: "0" }}>
      <path
        fill={`${starColor}4d`}
        d="M15.9199,11.8203 C15.6599,12.0703 15.5399,12.4393 15.6009,12.7903 L16.4899,17.7103 C16.5609,18.1303 16.3909,18.5493 16.0399,18.7903 C15.6999,19.0403 15.2499,19.0703 14.8699,18.8703 L10.4409,16.5603 C10.2799,16.4803 10.1099,16.4293 9.9409,16.4293 L9.6699,16.4293 C9.5699,16.4393 9.4809,16.4803 9.3999,16.5193 L4.9699,18.8403 C4.7499,18.9503 4.4999,18.9903 4.2599,18.9503 C3.6599,18.8303 3.2709,18.2693 3.3699,17.6793 L4.2599,12.7593 C4.3199,12.4003 4.1999,12.0403 3.9409,11.7803 L0.3299,8.2803 C0.0299,7.9803 -0.0801,7.5493 0.0609,7.1503 C0.1909,6.7593 0.5299,6.4693 0.9499,6.4003 L5.9199,5.6793 C6.2999,5.6393 6.6299,5.4103 6.7999,5.0703 L8.9899,0.5803 C9.0399,0.4803 9.1099,0.3893 9.1909,0.3103 L9.2799,0.2403 C9.3199,0.1893 9.3799,0.1503 9.4409,0.1103 L9.5499,0.0703 L9.7199,0.0003 L10.1409,0.0003 C10.5209,0.0403 10.8509,0.2693 11.0209,0.5993 L13.2399,5.0703 C13.3999,5.4003 13.7099,5.6203 14.0699,5.6793 L19.0399,6.4003 C19.4599,6.4603 19.8109,6.7503 19.9499,7.1503 C20.0799,7.5493 19.9699,7.9903 19.6599,8.2803 L15.9199,11.8203 Z"
        transform="translate(2 2.5)"
      />
      <path
        fill={starColor}
        clipPath=" inset(0 50% 0 0)"
        d="M15.9199,11.8203 C15.6599,12.0703 15.5399,12.4393 15.6009,12.7903 L16.4899,17.7103 C16.5609,18.1303 16.3909,18.5493 16.0399,18.7903 C15.6999,19.0403 15.2499,19.0703 14.8699,18.8703 L10.4409,16.5603 C10.2799,16.4803 10.1099,16.4293 9.9409,16.4293 L9.6699,16.4293 C9.5699,16.4393 9.4809,16.4803 9.3999,16.5193 L4.9699,18.8403 C4.7499,18.9503 4.4999,18.9903 4.2599,18.9503 C3.6599,18.8303 3.2709,18.2693 3.3699,17.6793 L4.2599,12.7593 C4.3199,12.4003 4.1999,12.0403 3.9409,11.7803 L0.3299,8.2803 C0.0299,7.9803 -0.0801,7.5493 0.0609,7.1503 C0.1909,6.7593 0.5299,6.4693 0.9499,6.4003 L5.9199,5.6793 C6.2999,5.6393 6.6299,5.4103 6.7999,5.0703 L8.9899,0.5803 C9.0399,0.4803 9.1099,0.3893 9.1909,0.3103 L9.2799,0.2403 C9.3199,0.1893 9.3799,0.1503 9.4409,0.1103 L9.5499,0.0703 L9.7199,0.0003 L10.1409,0.0003 C10.5209,0.0403 10.8509,0.2693 11.0209,0.5993 L13.2399,5.0703 C13.3999,5.4003 13.7099,5.6203 14.0699,5.6793 L19.0399,6.4003 C19.4599,6.4603 19.8109,6.7503 19.9499,7.1503 C20.0799,7.5493 19.9699,7.9903 19.6599,8.2803 L15.9199,11.8203 Z"
        transform="translate(2 2.5)"
      />
    </svg>
  );
};
